{
  "nl": {
    "validation": {
      "emailAddressDemo": "Het emailadres van een contact in deze demo client moet eindigen op '{email_address_suffix}' of '@ziggu.io'",
      "emailTaken": "Emailadres is al in gebruik",
      "import": {
        "inclusion": "Fout in regel {rowNumber} kolom {columnNumber}: {headerName} is niet opgenomen in de lijst",
        "inclusion_values": "met toegestane waarden: {values}",
        "invalid": "Fout in regel {rowNumber} kolom {columnNumber}: {headerName} is niet geldig",
        "required": "Fout in regel {rowNumber} kolom {columnNumber}: een waarde voor {headerName} is vereist",
        "unique": "Fout in regel {rowNumber}: {headerName} is niet uniek, er is nog een rij met deze waarde"
      },
      "nameAlreadyTaken": "Naam is al ingenomen",
      "needCompany": "Bedrijf is vereist",
      "needName": "Naam is verplicht"
    }
  }
}
